import React, { useState, useEffect } from "react";
import { Eye, EyeOff, Lock, User } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { HTTP } from "../../api/http-common";
import { isValidEmail } from './../../component/common';
import { useGlobalContext } from "./../../component/GlobalContext";
import Swal from 'sweetalert2'



const Verify = function () {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passcode, setPasscode] = useState("");
  const [passcodeError, setPasscodeError] = useState("");
  const [passcodeShow, setPasscodeShow] = useState(false);
  // const { user, setUser, theme, setTheme, language, setLanguage } = useGlobalContext();
  const { globalUserVar, setGlobalUserVar, setIsAuthenticated, usermailToVerify } = useGlobalContext();
  useEffect(() => {
    let registered_email = localStorage.getItem('registered_email');
    // alert(registered_email);
    if (registered_email != null && registered_email !== "") {
      setEmail(registered_email);
    }
  }, []);

  const resetValidationErrors = () => {
    //   setEmailError('');
    setPasscodeError('');
  };

  const validateField = () => {
    let checked = true;

    resetValidationErrors();

    if (email === '') {
      setEmailError('Please enter email address');
      checked = false;
    }
    else if (!isValidEmail(email)) {
      setEmailError('Invalid email.');
      checked = false;
    }

    if (passcode === '') {
      setPasscodeError('Please enter code');
      if (checked) {
        checked = false;
      }
    } else if (passcode.length < 6 || passcode.length > 6) {
      setPasscodeError("Please enter 6 characters long number code");
      if (checked) {
        checked = false;
      }
    }

    return checked;
  };

  const validateResendField = () => {
    let checked = true;

    resetValidationErrors();

    if (email === '') {
      setEmailError('Please enter email address');
      checked = false;
    }
    else if (!isValidEmail(email)) {
      setEmailError('Invalid email.');
      checked = false;
    }

    return checked;
  };

  const resendCode = async () => {
    if (validateResendField()) {
      try {

        let fields = {
          email: email,
        };

        await HTTP.post(
          "/user/resend-otp",
          fields,
          // config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: "Code sent successfully!",
                // text: "You can login now!",
                icon: "success"
              });
              // navigate('/login');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              setPasscodeError(error.response.data.detail);
            }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };
  const hideShowPass = () => {
    setPasscodeShow(!passcodeShow);
  }
  const handleSubmit = async () => {
    if (validateField()) {
      try {

        let fields = {
          email: email,
          otp: passcode,
        };

        await HTTP.post(
          "/user/verify-otp",
          fields,
          // config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: "Verified successfully!",
                text: "You can login now!",
                icon: "success"
              });
              localStorage.setItem('registered_email',email);
              const role = localStorage.getItem("role");
              if(role === "vendor"){
                navigate('/subscription/vendor');
              }else{
                navigate('/subscription/member');
              }
              localStorage.removeItem("role");
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              setPasscodeError(error.response.data.detail);
            }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };
  const fetchUserData = () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    };
    HTTP.get("user/me", config, config)
      .then((response) => {
        if (response.status === 200) {

          localStorage.setItem('userObj', JSON.stringify(response.data));
          setGlobalUserVar(JSON.stringify(response.data))
          setIsAuthenticated(response.data.email_verified)
          navigate('/dashboard');
        }
      })
      .catch((error) => {
        console.log(error);

      });
  };

  return (
    <div
      className="rounded-xl border bg-card text-card-foreground w-full p-8 shadow-sm max-w-[450px] min-h-[450px]"
      style={{ maxHeight: '580px', height: '100%', overflow: 'scroll' }}
    >
      <div className="flex gap-6 mb-6 mt-4">
        <button className="text-2xl font-semibold">Verify OTP</button>
      </div>
      <div className="flex flex-col gap-8">
        <div className="relative space-y-1">
          <div className="relative space-y-1">
            <input
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
              placeholder=" "
              value={email}
              name="username"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
            Email
          </label>
          {emailError && <span className="text-sm text-red-500">{emailError}</span>}
          <br></br>
          <div className="text-right"><p className="text-sm text-muted-foreground">Didn't receive the code? <Link onClick={resendCode} className="text-primary hover:underline font-medium">Resend</Link></p></div>

        </div>
        <div className="relative space-y-1">
          <div className="relative space-y-1">
            <input
              type={passcodeShow ? "text" : "password"}
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              placeholder=" "
              value={passcode}
              name="passcode"
              onChange={(e) => {
                setPasscode(e.target.value);
              }}
            />
          </div>
          <label className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500">
            Code
          </label>
          {passcodeError && <span className="text-sm text-red-500">{passcodeError}</span>}
          <button type="button" className="absolute right-0 bottom-2 text-gray-400" onClick={hideShowPass}>
            {passcodeShow ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
          </button>
        </div>
        <div className="">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 login-page-button-wrapper"
            type="submit"
            onClick={handleSubmit}
          >
            {/* <User className="mr-2 h-4 w-4" /> */}
            Verify
          </button>
        </div>

        <div>
          <Link
            to="/login"
            className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center"
          >
            <Lock className="mr-2 h-4 w-4" />
            Member's Sign In
          </Link>
          &nbsp;&nbsp;
          <Link
            to="/vendor/login"
            className="text-gray-500 hover:text-gray-700 text-sm inline-flex items-center"
          >
            <Lock className="mr-2 h-4 w-4" />
            Business Partner Sign In
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Verify
